// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3cmob","inner":"Form_inner__dBnFl","range":"Form_range__1Fk-w","name":"Form_name__3HqtC","actions":"Form_actions__mYq-i"};